module.exports = __webpack_public_path__ + "img/appmart.faa17f4e.svg";